export const DIRECTORIES = {
  BAM_PLAYLISTS: '/bam-playlists',
  MY_PLAYLISTS: '/my-playlists',
};

// TODO clean old paths and corresponding routes
export const PATHS = {
  HOME: '/',
  WEB_PLAYER: '/player',
  ABOUT: '/about',
  FAQ: '/faq',
  ADMIN: '/admin',
  PUBLISHER: '/publisher',
  OFFERS: '/offres',
  PAYMENT: '/payment',
  PLAYER: '/remote-player',
  WAITING_LIST: '/waiting-list',
  MY_PLAYLISTS: '/my-playlists',
  MY_PLAYLIST: `${DIRECTORIES.MY_PLAYLISTS}/:playlistId`,
  BAM_PLAYLIST: `${DIRECTORIES.BAM_PLAYLISTS}/:playlistId`,
  TERMS_OF_USE_AND_SALE: '/terms-of-use-and-sale',
  AUTHENTICATED_CASTING: '/authenticated-casting',
  CREATE_ACCOUNT: '/create-account',
  CLIENT: '/client',
  BAM_ONLINE_OFFERS: '/offers',
  GCU: '/cgv-cgu',
  COPYRIGHT: '/copyright',
  FORGOTTEN_PASSWORD: '/forgotten-password',
  CONFIRMATION: '/confirmation',
  HELP: '/assistance',
};

// TODO remove the constant (webplayer layout always shows player now)
export const PATHS_WITHOUT_PLAYER = [
  PATHS.PAYMENT,
  PATHS.OFFERS,
  PATHS.TERMS_OF_USE_AND_SALE,
  PATHS.CREATE_ACCOUNT,
];
export const PATHS_WITH_CASTING_BUTTON = [PATHS.WEB_PLAYER];
export const PATHS_WITHOUT_HEADER = [PATHS.WEB_PLAYER, PATHS.AUTHENTICATED_CASTING];

// TODO remove help link
export const PATHS_WITH_HELP_LINK = [
  PATHS.CREATE_ACCOUNT,
  PATHS.TERMS_OF_USE_AND_SALE,
  PATHS.ABOUT,
  PATHS.FAQ,
];

// TODO : handle internationalized paths in a cleaner way, so we can extend it to all the app
const REDIRECTED_PATHS = ['fr', 'en', 'es'].map((locale) => `${PATHS.HOME}${locale}`);
export const MICROPHONE_SIGNUP_PATHS = ['/fr/inscription-micro', '/en/signup-mic'];

// Used in new b2c routes to mark paths as unauthenticated
export const NON_AUTHENTICATED_PATHS = [
  PATHS.HOME,
  PATHS.GCU,
  PATHS.COPYRIGHT,
  PATHS.FAQ,
  PATHS.FORGOTTEN_PASSWORD,
  PATHS.HELP,
  ...REDIRECTED_PATHS,
  ...MICROPHONE_SIGNUP_PATHS,
];
